import React from 'react'
import { useLockBodyScroll } from "@uidotdev/usehooks";
export default function BlockOutsideClick() {
  useLockBodyScroll();
    
  return (
    <div className='blockClickContainer'>

    </div>
  )
}
